export type Theme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'optoscale-theme';
export const THEME_ELIGIBLE_KEY = 'optoscale-theme-eligible';

export interface ThemeState {
    theme: Theme;
    /** True when the user may switch themes (the `dark-mode` flag is on). */
    canToggle: boolean;
}

export interface ThemeActions {
    setTheme: (theme: Theme) => void;
    toggleTheme: () => void;
}
